const UpArrowIcon = (props: any) => {
    return (
        <svg width={12} height={15} viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M6 1L6 14M6 1L1 6M6 1L11 6"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default UpArrowIcon;
